"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Filter = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icons = _interopRequireDefault(require("../Icons/Icons"));

var _Text = require("../Text/Text");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = require("../../Theme/Theme.variables");

var _styledSystem = require("styled-system");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  padding: 8px;\n  transition: all 0.2s ease;\n  color: ", ";\n  line-height: 1;\n  z-index: 20;\n\n  > span {\n    font-size: 10.24px;\n    line-height: 1;\n    display: block;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  text-align: center;\n  width: 26px;\n  padding: 4px 0;\n  transition: all 0.2s ease 0s;\n  transform-origin: right center;\n  border-width: 1px;\n  border-style: solid;\n  background-color: ", ";\n  border-color: ", ";\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 20;\n\n  svg {\n    transform: translateX(-200%);\n    opacity: 0;\n    transition: all 0.2s ease;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  position: relative;\n  cursor: pointer;\n  z-index: 0\n\n  &:before {\n    content: '';\n    display: block;\n    width: 100%;\n    height: 100%;\n    transform: scaleX(0);\n    transform-origin: left center;\n    background-color: ", ";\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 10;\n    transition: all 0.1s ease-in;\n  }\n\n  ", ";\n  ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  &:before {\n    transform: scaleX(1);\n    transition: all 0.1s ease 0.05s;\n  }\n\n  & > span:nth-child(1) {\n    background-color: white;\n    svg {\n      transform: translateX(0%);\n      opacity: 1;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var activeCSS = (0, _styledComponents.css)(_templateObject());

var FilterWrap = _styledComponents.default.div(_templateObject2(), function (props) {
  return props.bgColor === 'white' ? (0, _Theme.variables)(props).grayLighter : props.bgColor;
}, function (props) {
  return props.isActive && activeCSS;
}, _styledSystem.space);

var FilterCheck = _styledComponents.default.span(_templateObject3(), function (props) {
  return props.bgColor === 'white' ? (0, _Theme.variables)(props).grayLight : props.bgColor;
}, function (props) {
  return props.bgColor === 'white' ? (0, _Theme.variables)(props).grayLight : props.bgColor;
});

var FilterLabel = _styledComponents.default.span(_templateObject4(), function (props) {
  return (0, _Theme.variables)(props).grayDark;
});

var Filter = function Filter(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  var filterLabel = props.filterLabel;
  var filterColor = props.filterColor ? props.filterColor : 'gray';

  var cleanedFilterColor = function cleanedFilterColor() {
    switch (filterColor.toLowerCase()) {
      case 'yellow':
        return '#f6eaab';

      case 'blue':
        return '#6779de';

      case 'purple':
        return '#8559c8';

      case 'red':
        return '#c4383f';

      case 'green':
        return '#2bb18f';

      case 'orange':
        return '#f9905b';

      case 'gray':
        return function (props) {
          return (0, _Theme.variables)(props).grayDark;
        };

      case 'grey':
        return function (props) {
          return (0, _Theme.variables)(props).grayDark;
        };

      case '':
        return function (props) {
          return (0, _Theme.variables)(props).grayDark;
        };

      default:
        return filterColor.toLowerCase();
    }
  };

  return _react.default.createElement(FilterWrap, _extends({
    className: "tracker-filter-".concat(filterLabel, "-20190611-145632"),
    title: filterLabel,
    bgColor: cleanedFilterColor()
  }, props), _react.default.createElement(FilterCheck, {
    bgColor: cleanedFilterColor()
  }, _react.default.createElement(_Icons.default.Check, {
    color: "grayDarker"
  })), _react.default.createElement(FilterLabel, null, _react.default.createElement(_Text.Text, {
    inline: true,
    small: true
  }, filterLabel)));
};

exports.Filter = Filter;
Filter.displayName = 'Filter'; // Prop Types

Filter.propTypes = {
  filterColor: _propTypes.default.string,
  filterLabel: _propTypes.default.string,
  isActive: _propTypes.default.bool
};
Filter.defaultProps = {
  filterLabel: 'Filter',
  isActive: false
};